import { PersonOutlineIcon } from '@occc/ui-design-system';
import { Switches } from '@occc-app/design-system';

import { MEMBERSHIP_AWARD_COUNT_LIMITS_PATH } from './fulfillment-limits.constants';

import type {
  AwardCountLimitPeriodOption,
  AwardCountLimitTimePeriod,
} from '../../award-count-limit';
import { StackedLimitRows } from '../stacked-limit-rows';
import { LimitFormContent } from '../limit-form-content';
import { LimitFormContentLayout } from '../limit-form-content-layout';
import { LimitComponentProps } from '../../types';

type PerMemberFulfillmentLimitProps = LimitComponentProps & {
  stacked?: boolean;
  periodOptions?: AwardCountLimitPeriodOption[];
  defaultPeriod?: AwardCountLimitTimePeriod;
};

export const PerMemberFulfillmentLimit = ({
  open,
  title,
  description,
  limitLabel,
  showAvatar = false,
  stacked = false,
  periodOptions,
  defaultPeriod,
}: PerMemberFulfillmentLimitProps) =>
  stacked ? (
    <StackedLimitRows
      formNamePath={MEMBERSHIP_AWARD_COUNT_LIMITS_PATH}
      open={open}
      title={title || 'Per Member Fulfillment Limits'}
      description={description ?? 'Per Member Fulfillment Limits'}
      limitLabel={limitLabel}
      avatar={showAvatar ? PersonOutlineIcon : undefined}
      periodOptions={periodOptions}
      defaultPeriod={defaultPeriod}
    />
  ) : (
    <LimitFormContentLayout
      title={title || 'Per Member Fulfillment Limit'}
      description={description ?? 'Per Member Fulfillment Limit'}
      action={<Switches name='awardCount.membership.isEnabled' data={{}} />}
      open={open}
      avatar={showAvatar ? PersonOutlineIcon : undefined}
    >
      <LimitFormContent name='awardCount.membership' limitLabel={limitLabel} />
    </LimitFormContentLayout>
  );
